import React, { forwardRef } from 'react';

const CustomButton = forwardRef(({
  children,
  h = 'fit-content',
  w = '100%',
  pd = '7px 30px',
  bg = 'none',
  mt = '0px',
  mb = '0px',
  ml = '0px',
  mr = '0px',
  color = 'black',
  border = 'none',
  borderRadius = '5px',
  style = {},
  action = () => { },
  className = '',
  disabled = false // una nueva prop para el estado disabled
}, ref) => {
  const handleAction = (e) => {
    if (disabled) return; // No ejecutar action si está deshabilitado
    e.stopPropagation();
    action();
  };

  return (
    <div
      ref={ref} // Pasa el ref al contenedor
      className={className}
      style={{
        height: h,
        width: w,
        padding: pd,
        background: bg,
        marginTop: mt,
        marginBottom: mb,
        marginLeft: ml,
        marginRight: mr,
        color,
        border,
        borderRadius,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1, // Cambiar la opacidad cuando esté deshabilitado
        ...style
      }}
      onClick={handleAction}
    >
      {children}
    </div>
  );
});

export default CustomButton;
